<template lang="pug">
.tiny-tag
  slot
</template>

<script>
export default {
  name: 'TinyTag',
}
</script>

<style lang="scss" scoped>
.tiny-tag {
  display: inline;
  background-color: #1e5896;
  color: white;
  border-radius: 4px;
  padding: 2px 5px;
  font-weight: bold;
  font-size: 0.7rem;
}
</style>
